import { Auth0ContextInterface, useAuth0, User } from '@auth0/auth0-react'

import { usePermissions } from '@/providers/PermissionsProvider'
import { getRole, Role } from '@/utils/role'

export type { Role } from '@/utils/role'

const NAMESPACE = import.meta.env.VITE_AUTH0_NAMESPACE
const ROLES_ENFORCED =
  import.meta.env.VITE_AUTH0_REPORTER_ROLES_ENFORCED === 'true'
const COURT_REPORTER_ROLE_ENABLED =
  import.meta.env.VITE_AUTH0_COURT_REPORTER_ROLE_ENABLED === 'true'

export type AuthUser = User & {
  id: string
  role: Role | null
  featureFlags: string[]
}

export const useAuth = (): Auth0ContextInterface<AuthUser> => {
  const auth0 = useAuth0()
  const permissions = usePermissions()
  // sub is `<strategy>|<id>` (e.g. auth0|x, google-oauth2|x) or, for enterprise
  // connections, `<strategy>|<connection>|<id>` (okta|Okta|x) — take the last segment.
  const id = auth0.user?.sub?.split('|').pop() as string
  const role = getRole(permissions, ROLES_ENFORCED, COURT_REPORTER_ROLE_ENABLED)

  const featureFlags = auth0.user?.[`${NAMESPACE}/feature-flags`] || []

  return {
    ...auth0,
    user: auth0.user ? { ...auth0.user, id, role, featureFlags } : undefined,
  }
}
